<template>
    <v-card>
    <v-container fluid>
    <v-card>
    <form ref="form"
    v-model="valid"
    lazy-validation>
        <v-spacer></v-spacer>
        <v-row align="end"
        style="height: 150px">
            <v-col  cols="12" sm="6" md="3">
            <v-container>
                <template>
                <v-file-input v-model="editedItem.files"
                    accept=".xlsx"
                    label="Archivo excel"
                    placeholder="Seleccione su archivo"
                    name="file"  
                    id="file"
                ></v-file-input>
                </template>
            </v-container>
            </v-col>
              <v-col align-self="center" cols="12" sm="6" md="4">
                <v-btn :disabled="editedItem.files.length == 0" color="primary" @click="carga">Cargar</v-btn>
            </v-col>
            <v-col align-self="center" cols="12" sm="6" md="3">
                <v-btn color="primary" @click="submit">Buscar OCs</v-btn>
            </v-col>
        </v-row>
    </form>  
      <v-spacer></v-spacer>
      </v-card>
      </v-container>
      <v-container fluid>
        <v-card>
         <v-card-title>
           <v-icon x-large>mdi-clipboard-list-outline</v-icon>OCs Bloqueadas
           <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filtro"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
        :headers="headers"
        :items="mvm"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
      
        <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
        <v-icon
            small
            class="mr-2"
            v-bind="attrs"
            v-on="on"
            @click="openDialogDeleteItem(item)"
        >
            mdi-delete
        </v-icon>
        </template>
        <span>Eliminar</span>
        </v-tooltip>
        </template>
     
      </v-data-table>
      </v-card>
      </v-container>
      <v-spacer></v-spacer>

      <div class="text-center d-flex justify-space-around">
        <v-btn type="button" color="primary" @click="onexport" class="mx-4">Descargar Detalle</v-btn>
      </div>

      <v-dialog v-model="dialog_new" max-width="900px">
      <v-stepper v-model="e1" vertical>
             <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
            <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">{{ this.step_txt1 }}
                <small>{{this.step_txt2}}</small>
            </v-stepper-step>
            <v-stepper-content step="1">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
                {{this.msj_proceso}}
                </div>
            </v-card>
            </v-stepper-content>  
        </v-stepper>
      </v-dialog>

      <!-- Pop up borrar -->
      <v-dialog v-model="dialog_delete" max-width="350">
          <v-card class="px-2 py-2">
            <v-card-title class="headline mb-3"> ¿Desea borrar bloqueo?</v-card-title>
            <v-spacer></v-spacer>
            <v-card-actions>
            <v-spacer></v-spacer>
          <div>
            <v-btn color="primary" @click="close">Volver</v-btn>
            <v-btn color="error" @click="deleteRegistry" >Borrar</v-btn>
          </div>
                
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
    
    <script>
    import axios from 'axios'
    //import Vue from "vue";
    //import JsonExcel from "vue-json-excel";
    import XLSX from 'xlsx';
     
    //Vue.component("downloadExcel", JsonExcel);
    
    export default {
      data: () => ({
        
        search: '',
        search2: '',
        api_tool_url: process.env.VUE_APP_API_TOOL_URL,
        dialog: false,
        dialog_new: false,
        dialog_delete:false,
        valid: true,
        menu: false,
        menu2: false,
        e1: 0,
        btnap:true,
        btn: false,
        msj_proceso:'',
        progressBar1: false,
        progressBar: false,
        overlay: false,
        step_error1: true,
        step_error2: true,
        step_error3: true,
        step_color1:"primary",
        step_color2:"primary",
        step_color3:"primary",
        RequestProposal_id:'',
        step_txt1:'',
        step_txt2:'',
        TurningStorageArea_id:'',
        TurningStorageArea_Desc:'',
        OpPoint_id: '',
        Supplier_Description:'',
        VendorPurchaseOrder_Num:'',
        Section_id:'',
        LastOpRepUser_id: '',
        RepEvent_Dttm: '',
        ApiUser_GivenName:'',
        status:'',
        CDay_id:'',
        CHour_Description:'',
        DateMvm:'',
        id_process:'',
        isTester: false,
        deleteIndex:'',
        headers: [
          { text: 'Actions', value: 'action', sortable: false },
          { text: 'OC', value: 'VendorPurchaseOrder_Num' },
          { text: 'Punto', value: 'OpPoint_id' },
          { text: 'Razón Social', value: 'supplier_description' }
        ],
        mvm: [{VendorPurchaseOrder_Num:"Cargando...", OpPoint_id:"Cargando...", supplier_description:'Cargando...'}],
        tdetalle: [],
        seleccion:[],
        RequestMVM: ['Número de Orden', 'Punto'],
        tdetalle_vew: [],
        editedIndex: -1,
        editedItem: {
          seleccion:['Número de Orden', 'Punto'],
          files: []
        },
        
        
        config: {
          headers: {
            //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
          }
        }
      }),
    
      created () {
        this.overlay = true
        this.initialize()
      },
    
      methods: {
        initialize () {
            
            axios.post(this.api_tool_url + '/get_blockedOC', {}, this.config)
            .then(response => { 
              console.log(response.data.ResultRows)
                this.mvm = response.data.ResultRows
            })
            .catch(error => {
                this.mvm = []
                alert(error.response.data.message)
                
            })
        },
    
        carga() {
            this.btn = true
            this.step_txt1="Buscando OCs"
            this.step_txt2="Consultando"
            this.dialog_new = true
            this.e1 = 1
            this.progressBar = true
            this.step_error1 = true
            this.step_error2 = true
            this.step_error3 = true
            this.btnap=true
            this.step_color1 = "primary",
            this.step_color2 = "primary",
            this.step_color3 = "primary",
            this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
            let data = new FormData();
            this.mvm = []
            data.append('foo', 'bar');
            data.append('file', document.getElementById('file').files[0]);
            data.append('email', sessionStorage.getItem('ApiUser_EMail'));
            data.append('user', sessionStorage.getItem('ApiUser_id'));


        axios.post(this.api_tool_url + '/fileUpload_blockedOC', data, this.config)
        .then(response => {
                //if(response.data.ResultRows.length >= 1) {
                if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {

                    this.mvm = response.data.ResultRows
                    this.id_process = response.data.Proceso_id                         
                    if(response.data.status == "NoOK")
                    {
                        this.btnap=true
                    }
                    else{
                        this.btnap=false
                    }
                    this.e1 = 1
                    this.step_color1 = "#008000"
                    this.progressBar = false
                    this.msj_proceso = 'Se cargó el archivo correctamente.'
                    this.btn = false
                    this.active = false  
                    setTimeout(this.close, 3000)
                }
                else {
                    this.e1 = 1
                    this.step_color1 = "#C0392B"
                    this.progressBar = false
                    this.msj_proceso = error
                    this.btn = false
                    this.active = true
                }
                this.btn = false
            })
            .catch(error => {
                this.btn = false
                this.step_error1 = false
                this.progressBar = false
                if (error.response && error.response.data && error.response.data.message) {
                    this.msj_proceso = error.response.data.message;
                } else {
                    this.msj_proceso = 'Ocurrió un error al procesar el archivo.';
                }
                this.active = true
            })
        },

        openDialogDeleteItem (item) {
          this.dialog_delete = true
          this.deleteIndex = this.mvm.indexOf(item)
          //console.log(item)
          //console.log(this.deleteIndex)
          //confirm('Are you sure you want to delete this item?') && this.deleteSustitucion(index)
        },

        deleteRegistry() {
            let tmpObj = this.mvm[this.deleteIndex]
            //console.log(tmpObj)
            let tpm = {
                OpPoint_id: tmpObj.OpPoint_id,
                VendorPurchaseOrder_Num: tmpObj.VendorPurchaseOrder_Num
            }
            //console.log(tpm)
            
            axios.post(this.api_tool_url + "/del_blockedOC", tpm, this.config)
            .then(response => {
            //this.items.splice(this.deleteIndex, 1)
            this.mvm = []
            this.close()

            })
            .catch(error => {
                this.mvm = []
                alert(error.response.data.message)
                this.close()
            })
        },
        close () {
            this.dialog_new = false
            this.dialog_delete = false
        },

        submit(){
            this.step_txt1="Buscando OCs"
            this.step_txt2="Consultando"
            this.dialog_new = true
            this.e1 = 1
            this.progressBar = true
            this.step_error1 = true
            this.step_error2 = true
            this.step_error3 = true
            this.step_color1 = "primary",
            this.step_color2 = "primary",
            this.step_color3 = "primary",
            this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
            this.mvm = []
            this.mvm_detail = []
            let filter = null
            filter = {Supplier:this.ApiUserSupplier}
            axios.post(this.api_tool_url + '/get_blockedOC',filter, this.config)
                .then(response => {

                    if(response.data.ResultRows.length >= 1)
                    {
                        this.id_process = response.data.Proceso_id 
                        // console.log(response.data.ResultRows)
                        this.mvm = response.data.ResultRows
                        this.e1 = 1
                        this.step_color1 = "#008000"
                        this.msj_proceso = "Propuestas cargadas."
                        this.active = false
                        this.progressBar = false
                        setTimeout(this.close, 3000)
                    }
                    else{
                        this.progressBar = false
                        this.msj_proceso = "No se encontraron turnos."
                        this.step_error1 = false
                        this.step_error2 = false
                        this.step_error3 = false
                    }
                    this.btn = false
                })
                .catch(error => {
                    this.mvm = []
                    this.btn = false
                    this.step_error1 = false
                    this.progressBar = false
                    this.msj_proceso = error.response.data.message
                })
            },


            onexport () { // On Click Excel download button
              // export json to Worksheet of Excel
            
              const header_d_f = ['OC','Punto', 'Razón social'];
              const header_d = ['VendorPurchaseOrder_Num', 'OpPoint_id', 'supplier_description'];
              var WS = XLSX.utils.json_to_sheet(this.mvm, {header: header_d}) 

              var range = XLSX.utils.decode_range(WS['!ref']);
              for(var C = range.s.c; C <= range.e.c; ++C) {
                var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
                WS[colum].v = header_d_f[C];
              }

              range.e['c'] = header_d_f.length - 1;
              WS['!ref'] = XLSX.utils.encode_range(range);

              // A workbook is the name given to an Excel file
              var wb = XLSX.utils.book_new() // make Workbook of Excel

              // add Worksheet to Workbook
              // Workbook contains one or more worksheets
              // sheetAName is name of Worksheet
              XLSX.utils.book_append_sheet(wb, WS, 'OCs bloqueadas')  
              let now = new Date();

              let year = now.getFullYear();
              let month = String(now.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
              let day = String(now.getDate()).padStart(2, '0');
              let hours = String(now.getHours()).padStart(2, '0');
              let minutes = String(now.getMinutes()).padStart(2, '0');

              var file='BlockedOCs_'+year+month+day+hours+minutes+'.xlsx';

              // export Excel file
              XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
            }
      }
    }
    </script>
    


// WEBPACK FOOTER //
// src/components/BlockOC.vue